<template>
  <Wrapper>
    <main class="inventory_delivery-content">
      <header>
        <h1 v-if="isMobile">{{ getMobileHeader() }}</h1>
        <h1 v-else>Вътрешни заявки към отдел доставки</h1>

        <section class="btns-wrapper">
          <TheInput
            showAsIcon="g"
            prop="name"
            propValue="value"
            type="dropdown"
            :fixed="true"
            :options="filters"
            fixedLabel="ФИЛТРИРАНЕ"
            v-model="filter"
            @update:modelValue="setFilter($event)"
          />
          <TheInput
            showAsIcon="2"
            prop="name"
            propValue="value"
            type="dropdown"
            :fixed="true"
            :isSort="true"
            :options="sortTypes"
            fixedLabel="СОРТИРАНЕ"
            v-model="sortBy"
            @update:modelValue="setSort($event)"
          />

          <button
            v-if="accessCache['can_add']"
            class="btn btn-new"
            @click="addDelivery()"
          >
            <span class="mck">L</span>
            Нова заявка
          </button>
        </section>
      </header>

      <section class="mobile-content mobile">
        <div class="no-results" v-if="!deliveries.length">
          <p>Няма намерени резултати</p>
        </div>
        <div
          class="mobile-content_element mobile-content_element--delivery"
          v-else
          v-for="d of deliveries"
          :key="d._id"
          @click="toggleActions(d, true)"
        >
          <TheFixedDropdown
            v-if="d.showActions"
            prop="name"
            label="ДЕЙСТВИЯ"
            :arr="getActions(d)"
            @selected="handleAction($event.value, d)"
            @close="toggleActions(d)"
          />

          <section class="content">
            <section class="row">
              <div class="row row--column">
                <p>
                  <strong>{{ d.deliveryNumber }}</strong> /
                  {{ format(new Date(d.createdAt), "dd.MM.yyyy") }}
                </p>
                <p>
                  <strong>{{ d.createdBy.name }}</strong>
                </p>
              </div>

              <div class="row">
                <Status :s="d.status" />
                <span class="mck3 flag" :class="`flag--${d.urgency}`">S</span>
              </div>
            </section>
            <hr />
            <section class="row">
              <div>
                <p>
                  {{ format(new Date(d.deliveryDate), "dd.MM.yyyy") }}
                </p>
                <p>
                  <strong>{{ d.deliveryFor }}</strong>
                </p>
              </div>
            </section>
            <hr />
            <section class="row">
              <div>
                <template v-if="!d.location">-</template>
                <div v-else>
                  <p>{{ d.location.companyName }} &gt;</p>
                  <p>
                    <strong>{{ d.location.projectName }}</strong>
                  </p>
                </div>
              </div>
            </section>
          </section>
        </div>
      </section>

      <div v-if="!isMobile" class="table-wrapper table-wrapper--new">
        <table class="table">
          <thead>
            <tr>
              <th style="width: 20px"></th>
              <th>
                <p class="thin">№/ От дата</p>
                <p>ЗАЯВКА ОТ</p>
              </th>
              <th>
                <p class="thin">За дата</p>
                <p>ЗАЯВКА ЗА</p>
              </th>
              <th>ЗА ОБЕКТ</th>
              <th>
                <p>СТАТУС</p>
                <p>ОДОБРЕНО ОТ</p>
              </th>
              <th>
                <p>КОМЕНТАР</p>
                <p>ОТДЕЛ ДОСТАВКИ</p>
              </th>
              <th></th>
            </tr>
          </thead>
          <tbody v-if="!deliveries.length">
            <tr>
              <td colspan="7" class="center">Няма намерени резултати</td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr v-for="delivery of deliveries" :key="delivery._id">
              <td>
                <span class="mck3 flag" :class="`flag--${delivery.urgency}`"
                  >S</span
                >
              </td>
              <td>
                <div>
                  <p>
                    <strong>{{ delivery.deliveryNumber }}</strong> /
                    {{ format(new Date(delivery.createdAt), "dd.MM.yyyy") }}
                  </p>
                  <p>
                    <strong>{{ delivery.createdBy.name }}</strong>
                  </p>
                </div>
              </td>
              <td>
                <div>
                  <p>
                    {{ format(new Date(delivery.deliveryDate), "dd.MM.yyyy") }}
                  </p>
                  <p>
                    <strong>{{ delivery.deliveryFor }}</strong>
                  </p>
                </div>
              </td>
              <td style="width: 35%">
                <template v-if="!delivery.location">-</template>
                <template v-else>
                  <p>{{ delivery.location.companyName }} &gt;</p>
                  <p>
                    <strong>{{ delivery.location.projectName }}</strong>
                  </p>
                </template>
              </td>
              <td>
                <Status :s="delivery.status" />
                <p v-if="delivery.decisionBy">
                  {{ format(new Date(delivery.decisionDate), "dd.MM.yyyy") }} /
                  <strong>{{ delivery.decisionBy.name }}</strong>
                </p>
              </td>
              <td>{{ delivery.comment || "-" }}</td>
              <td>
                <TheInput
                  prop="name"
                  :options="getActions(delivery)"
                  type="dropdown"
                  placeholder="Действия"
                  @update:modelValue="handleAction($event.value, delivery)"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <Pagination
        :currentPage="page"
        :size="size"
        :total="totalDeliveries"
        @updage:page="pageChanged"
      />
    </main>

    <DeliveryModal
      v-if="idToEdit || isDeliveryModalOpen"
      :idToEdit="idToEdit"
      @close="closeDeliveryModal"
    />

    <transition name="fade">
      <FilesModal
        v-if="isFilesModalOpened"
        type="deliveries"
        :id="isFilesModalOpened"
        @close="closeFilesModal"
      />
    </transition>
  </Wrapper>
</template>

<script>
import { format } from "date-fns";
import { bg } from "date-fns/locale";
import { getAccess } from "./mixins/getAccess";
import { mapGetters } from "vuex";
import Wrapper from "@/components/Wrapper";
import DeliveryModal from "./delivery/DeliveryModal.vue";
import Pagination from "@/components/shared/Pagination.vue";
import TheInput from "@/components/TheInput";
import Status from "./shared/Status.vue";
import getMobile from "./mixins/getMobile.js";
import tabsData from "../data/tabsData";
import TheFixedDropdown from "./TheFixedDropdown.vue";
import FilesModal from "@/components/shared/FilesModal";
export default {
  mixins: [getMobile],
  components: {
    Status,
    Wrapper,
    TheInput,
    Pagination,
    DeliveryModal,
    TheFixedDropdown,
    FilesModal,
  },
  data() {
    return {
      bg,
      format,
      tabsData,
      deliveries: [],
      totalDeliveries: 0,
      isDeliveryModalOpen: false,
      isFilesModalOpened: false,
      filter: "",
      search: "",
      idToEdit: undefined,
      page: Number.parseInt(this.$route.query.page) || 1,
      size: 40,
      accessCache: {},
      sortBy: { deliveryNumber: 1 },
      actions: [
        { name: "Преглед и редакция", icon: ",", value: "idToEdit" },
        { name: "Изтриване", icon: "b", value: "deleteDelivery" },
      ],
      filters: [
        {
          name: "ВСИЧКИ",
          value: "all",
        },
        {
          name: "ОДОБРЕНИ",
          field: "status",
          value: "confirmed",
        },
        {
          name: "НЕОДОБРЕНИ",
          field: "status",
          value: "declined",
        },
        {
          name: "ЧАКАЩИ ОДОБРЕНИЕ",
          field: "status",
          value: "waiting",
        },
        {
          name: "САМО СПЕШНИ",
          field: "urgency",
          value: "high",
        },
      ],
      sortTypes: [
        {
          name: "Сортирай по номер",
          icon: "2",
          value: "deliveryNumber",
        },
        {
          name: "Сортирай по дата на въвеждане",
          icon: "2",
          value: "createdAt",
        },
        {
          name: "Сортирай по дата на заявка",
          icon: "2",
          value: "deliveryDate",
        },
        { name: "Сортирай по спешност", icon: "2", value: "urgency" },
        { name: "Сортирай по създател", icon: "2", value: "createdBy.name" },
        { name: "Сортирай по обект", icon: "2", value: "location" },
        { name: "Сортирай по статус", icon: "2", value: "status" },
      ],
    };
  },
  watch: {
    search() {
      this.getDeliveries();
    },
    $route() {
      this.getDeliveries();
    },
  },
  computed: {
    ...mapGetters(["getUser"]),
  },
  methods: {
    getMobileHeader() {
      const today = new Date();
      const dayName = format(today, "EEEE", { locale: bg });

      return `${dayName}, ${format(today, "dd.MM.yyyy")}`;
    },
    handleAction(value, d) {
      if (value === "confirmDelivery" || value === "declineDelivery") {
        this.deliveryAction(d, value === "confirmDelivery");
      }
      if (value === "deleteDelivery") this.deleteDelivery(d);
      else this[value] = d._id;

      this.toggleActions(d);
    },
    toggleActions(d, v) {
      this.$set(d, "showActions", v ? true : false);
    },
    getActions(d) {
      let actionsCopy = [...this.actions];

      if (d.files && d.files.length) {
        actionsCopy.push({
          name: "Виж документацията",
          icon: "Q",
          value: "isFilesModalOpened",
        });
      }

      if (!d.decisionBy && this.accessCache["can_accept"]) {
        actionsCopy.push(
          {
            name: "Потвърди заявка",
            icon: "I",
            iconClass: "mck3",
            value: "confirmDelivery",
          },
          {
            name: "Откажи заявка",
            icon: "F",
            value: "declineDelivery",
          }
        );
      }

      return actionsCopy;
    },
    pageChanged(page) {
      this.page = page;
      this.getReports();
    },
    closeDeliveryModal(isUpdated) {
      this.isDeliveryModalOpen = false;
      this.idToEdit = undefined;
      if (isUpdated) this.getDeliveries();
    },
    closeFilesModal(isUpdated) {
      this.isFilesModalOpened = false;
      if (isUpdated) this.getDeliveries();
    },
    updateQuery(query) {
      const currentQuery = { ...this.$route.query };
      const currentQueryString = JSON.stringify(currentQuery);
      const newQueryString = JSON.stringify(query);

      if (currentQueryString !== newQueryString) {
        this.$router.replace({ path: this.$route.path, query });
      }
    },
    setSort(v) {
      this.sortBy = v;
      this.updateQuery({
        ...this.$route.query,
        sortBy: JSON.stringify(this.sortBy),
      });
    },
    setFilter(filter) {
      this.filter = filter;

      this.updateQuery({
        ...this.$route.query,
        filter: JSON.stringify(this.filter),
      });
    },
    getQuery() {
      const { query } = this.$route;

      if (query) {
        // set default filter
        if (!query.filter) {
          const defFilter = this.filters[0]; // all

          this.filter = defFilter;
          this.updateQuery({
            ...this.$route.query,
            filter: JSON.stringify(defFilter),
          });
        }

        Object.entries(query).forEach(([key, value]) => {
          this[key] = JSON.parse(value);
        });
      }

      this.getDeliveries();
    },
    addDelivery() {
      this.isDeliveryModalOpen = true;
    },
    async deliveryAction(d, isConfirmed) {
      try {
        d.status = isConfirmed ? "confirmed" : "declined";
        d.decisionDate = new Date();
        d.decisionBy = this.getUser._id;

        const fd = new FormData();
        fd.append("data", JSON.stringify({ ...d }));

        let url = `${process.env.VUE_APP_BASE_URI}/deliveries/${d._id}`;
        await this.$http.put(url, fd);

        this.getDeliveries();
      } catch (err) {
        console.log(err);
      }
    },
    async deleteDelivery(d) {
      if (!confirm("Сигурни ли сте, че искате да изтриете заявката?")) return;
      try {
        let url = `${process.env.VUE_APP_BASE_URI}/deliveries/${d._id}`;
        await this.$http.delete(url);

        this.getDeliveries();
      } catch (err) {
        console.log(err);
      }
    },
    async getDeliveries() {
      try {
        this.deliveries = [];
        let url = `${process.env.VUE_APP_BASE_URI}/deliveries?page=${this.page}&size=${this.size}`;

        if (!this.accessCache["full"]) {
          url += `&createdBy=${this.getUser._id}`;
        }
        if (this.search) url += `&search=${this.search}`;
        if (this.sortBy) url += `&sortBy=${JSON.stringify(this.sortBy)}`;

        const { query } = this.$route;

        if (query) {
          if (query.filter) url += `&filter=${query.filter}`;
        }

        const res = await this.$http.get(url);

        this.deliveries = res.data.result;
        this.totalDeliveries = res.data.total;
      } catch (err) {
        console.log(err);
      }
    },
    setAccessCache() {
      Object.keys(this.tabsData.delivery.tabValues).forEach((key) => {
        this.accessCache[key] = getAccess(key, "delivery");
      });
      this.getQuery();
    },
  },
  async mounted() {
    await this.setAccessCache();
  },
  updated() {
    this.$root.$on("sendSearchInput", (data) => {
      this.search = data;
    });
  },
  destroyed() {
    this.$off("closeInventoryModal");
    this.$root.$off("sendSearchInput");
  },
};
</script>

<style scoped lang="scss">
.flag {
  color: #32a502;
  font-size: 20px;

  &.flag--mid {
    color: #d8a600;
  }
  &.flag--high {
    color: #b50c0c;
  }
}
.table {
  thead {
    th {
      .thin {
        font-weight: normal;
      }
    }
  }
  tbody {
    tr {
      td {
        height: 50px;
      }
    }
  }
}

@media screen and (max-width: 1000px) {
  .inventory-content {
    background: #fff 0 0 no-repeat padding-box;
    border: 1px solid #ccd1e3;
    display: flex;
    flex-direction: column;
    gap: 10px;
    flex-wrap: wrap;
    padding: 5px 10px;

    .btns-wrapper {
      display: flex;
    }
  }
}
</style>
